module.exports = __webpack_public_path__ + "static/media/user.8cb4a8d7.png";